//#region src/i18n/constants.ts
const SOURCE_LOCALE_ID = "en";
const PSEUDO_LOCALE_ID = "pseudo";
const SUPPORTED_LOCALE_IDS = [
	"be",
	"de",
	"en",
	"es",
	"fr",
	"hi",
	"ko",
	"pl",
	"ru",
	"tr",
	"uk"
];
//#endregion
export { PSEUDO_LOCALE_ID, SOURCE_LOCALE_ID, SUPPORTED_LOCALE_IDS };

//# sourceMappingURL=constants.js.map